export function Pager(props: { page: number; pageSize: number; total: number; onPage: (page: number) => void }) {
  const pages = Math.max(1, Math.ceil(props.total / props.pageSize));
  return (
    <div className="pager">
      <button type="button" disabled={props.page <= 1} onClick={() => props.onPage(props.page - 1)}>
        ‹ Prev
      </button>
      <span>
        page {props.page} of {pages} · {props.total} cards
      </span>
      <button type="button" disabled={props.page >= pages} onClick={() => props.onPage(props.page + 1)}>
        Next ›
      </button>
    </div>
  );
}
